// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop_box{padding:10px 20px 20px 30px}.shop_box>div{margin-bottom:20px}.cover-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.cover-uploader .el-upload:hover{border-color:#409eff}.addressDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.addressDiv div{-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
